<template lang="pug">
server-data.h-100(
  ref="list"
  :method="method"
  v-slot="{ serverData, search, init, loading, pagination }"
  :query="query"
  :serializeData="serializeData"
  :additionalQuery="extendParams"
)
  v-card.sdo-card.px-2(
    :loading="loading"
    height="100%"
  )
    .sticky
      v-sheet.py-2.align-center
        slot(name="list-header" v-bind="{ init, resetSearch }")
        v-text-field(
          v-model="searchKeys[queryField.key]"
          :label="queryField.label"
          :loading="loading"
          rounded filled hide-details
        )
          template(#prepend)
            v-menu(
              v-if="filters.length"
              :close-on-content-click="false"
              min-width="500px"
              max-width="500px"
              offset-x
              eager
            )
              template(v-slot:activator="{ on, attrs }")
                v-badge.mr-1(
                  color="primary"
                  :content="badgeCount"
                  :value="badgeCount"
                  overlap
                )
                  v-icon.pa-1(
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                  ) mdi-tune
              v-list.py-4
                v-list-item(
                  v-for="(filter, index) in filters"
                  :key="index"
                )
                  component.filter.mb-4(
                    :is="filter.component"
                    v-model="extendSearchKeys[filter.key]"
                    v-bind="filter.component_attrs"
                    return-object
                    hide-details
                    width="100%"
                    clearable
                  )
                v-list-item
                  v-btn.mr-2(@click="runSearch" color="primary") Найти
                  v-btn(@click="resetSearch") Сбросить
          template(#append-outer)
            v-btn(
              color="primary"
              depressed fab small
              @click="search"
            )
              v-icon mdi-magnify
        slot(name="list-header-bottom" v-bind="{ init, resetSearch }")
        search-chips(
          v-if="showChips"
          :search="extendSearchKeys"
          @delete="deleteSearch"
        )
    v-list.overflow-y-auto.scroll(
      v-if="serverData && serverData.length && !loading"
      height="100%"
    )
      v-list-item-group(
        v-model="selected"
      )
        v-list-item(
          v-for="(item, index) in serverData" :key="index"
          :value="item"
        )
          slot(name="list-item" v-bind="{ item, index }")
        //- div(v-if="serverData.length"
        //- v-intersect="onIntersect")
    v-card-actions.white(
    )
      v-pagination(
        v-if="pagination && pagination.pages   > 1"
        v-model="pagination.page"
        :length="pagination.pages"
        @input="init"
      )
      v-spacer
      ev-chip(v-if="pagination" color="primary" small :text="`${pagination.total}` || '2'")
    v-alert.ma-2(v-if="!serverData.length && !loading"  type="info") Данные отсутсвуют
</template>

<script>
import SearchChips from './SearchChips.vue';

export default {
  components: { SearchChips },
  props: {
    isCrudDetails: { type: Boolean, default: false },
    value: { type: Object, default: () => ({}) },
    method: { type: Function, required: true },
    isMobile: { type: Boolean, default: false },
    pagination: { type: Boolean, default: true },
    filters: { type: Array, default: () => ([]) },
    queryField: { type: Object, default: () => ({ label: 'Название', key: 'name' }) },
    additionalQuery: { type: Object, default: () => {} },
    additionalParams: { type: Object, default: () => ({}) },
    showChips: { type: Boolean, default: false },
    serializeData: { type: Function, default: (data) => data },
    queryData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      noClose: false,
      page: 1,
      selected: null,
      searchKeys: {},
      extendSearchKeys: {},
    };
  },
  computed: {
    query() {
      return {
        ...this.queryData,
        ...this.searchKeys,
        ...this.pagination ? { page: this.page } : {},
      };
    },
    defaultSearchKeys() {
      const searchKeys = {};
      this.filters
        .filter((filter) => filter.default)
        .forEach((filter) => { searchKeys[filter.key] = filter.default; });
      return searchKeys;
    },
    extendParams() {
      return {
        ...this.additionalParams,
        ...this.additionalQuery,
        ...this.convertSearchKeys(this.defaultSearchKeys),
      };
    },
    badgeCount() {
      const filters = Object.entries(this.extendSearchKeys);
      return filters.filter((item) => item[1]).length;
    },
  },
  watch: {
    value: {
      handler(val) {
        if (!val) this.selected = null;
      },
      immediate: true,
    },
    selected(val) {
      this.$emit('input', val);
      if (!this.noClose) this.$emit('close');
      this.noClose = false;
    },
  },
  mounted() {
    this.resetSearch();
  },
  methods: {
    openCU(item) {
      this.noClose = true;
      this.selected = item;
      this.$emit('openCU');
    },
    runSearch() {
      const searchKeys = Object.entries(this.convertSearchKeys(this.extendSearchKeys));
      searchKeys.forEach(([key, value]) => this.$set(this.searchKeys, key, value));
    },
    resetSearch() {
      this.searchKeys = { ...this.convertSearchKeys(this.defaultSearchKeys) };
      this.extendSearchKeys = { ...this.defaultSearchKeys };
    },
    deleteSearch(key) {
      this.searchKeys[key] = null;
      this.extendSearchKeys[key] = null;
    },
    convertSearchKeys(obj) {
      const newSearch = {};
      const searchKeys = Object.entries(obj);
      if (searchKeys.length) {
        searchKeys.forEach(([key, value]) => {
          const val = Array.isArray(value) ? value.map((i) => i.id || i) : value?.id || value;
          newSearch[key] = val;
        });
      }
      return newSearch;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  ::v-deep .v-list-item__title {
    white-space: normal !important;
  }
}
.v-list {
  overflow-y: auto;

  & {
    scrollbar-width: thin;
    scrollbar-color: var(--primary-color);
  }

  /* Works on Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--primary-color);
    border-radius: 20px;
  }
}
</style>
